import React, { useState } from 'react'
import { Checkbox, FormControlLabel, MenuItem, Radio, RadioGroup, Select } from '@material-ui/core';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { putBulkUpdate } from '../thunks/putBulkUpdate';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { setSearchAllV2 } from "../../contractManagement/AppStore/ActionCreator/commonDataAction";
import { showDetailedErrorSwal } from '../../components/common components/showErrorSwal';

const BulkEmpty = () => {
    const dispatch = useDispatch()

    const [distribution, setDistribution] = useState([])

    const checkBoxMappings = {
        'Business': 'Business',
        'Economy': 'Economy',
        'Premium Business': 'PremiumBusiness',
        'Premium Economy': 'PremiumEconomy',
        'First Class': 'First',
        'Cheque': 'CHEQUE',
        'Credit Card': 'CREDITCARD',
        'Credit Internal': 'CREDITINTERNAL',
        'Sky Link': 'Sky Link',
        'Intair Transit': 'Intair Transit',
        'Fun Sun': 'Fun Sun',
        'DFW': 'DFW',
        'Sunquest': 'Sunquest',
        'Network': 'Network'
    }

    const checkBoxObject = useSelector((state) => state.commonDataReducer.checkBoxObject);
    const history = useHistory();


    const [bulkEdit, setBulkEdit] = useState({
        "marketingAirline": false,
        "operatingAirline": false,
        "airportNotAllowed": false,
        "cannotBeDistributed": false,
        "distribution": false,
        "PCCDuTariff": false,
        "OSI": false,
        "branchFiles": false,
        "issueAsBulk": false,
        "accountCode": false,
        "ticketDesignator": false,
        "lastReturnDate": false,
        "lastTicketingDate": false,
        "endorsement": false,

    });

    const handleBulkEdit = (name) => {
        let copyBulkEdit = { ...bulkEdit };

        copyBulkEdit[name] = !(copyBulkEdit[name]);

        setBulkEdit(copyBulkEdit);
    }

    const CheckBoxTypeSelector = ({ checkBoxTypes, mainLabel, setMethod, useStateVariable = [] }) => {
        const handleCheckboxChange = (e, cabinType) => {
            if (useStateVariable.includes(cabinType)) {
                setMethod(useStateVariable.filter((type) => type !== cabinType));
            } else {
                setMethod([...useStateVariable, cabinType]);
            }
        };

        return (
            <div className={"col-md-3 cm-col"}>
                <label className="cm-head-label">{mainLabel}</label>

                <div className="row">
                    {checkBoxTypes.map((checkBox, index) => (
                        <div key={index} className="col-md-6">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={useStateVariable.includes(checkBoxMappings[checkBox])}
                                        onChange={(e) => handleCheckboxChange(e, checkBoxMappings[checkBox])}
                                        disabled={true}
                                    />
                                }
                                label={checkBox}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const saveHandle = async () => {
        let tarifData = {
            "marketingAirline": bulkEdit?.marketingAirline ? "" : undefined,
            "mappedOpeartingAirlines": bulkEdit?.operatingAirline ? "" : undefined,
            "DFW": bulkEdit?.distribution ? null : undefined,
            "funSun": bulkEdit?.distribution ? null : undefined,
            "intairTransit": bulkEdit?.distribution ? null : undefined,
            "skyLink": bulkEdit?.distribution ? null : undefined,
            "sunquest": bulkEdit?.distribution ? null : undefined,
            "network": bulkEdit?.distribution ? null : undefined,
            "disallowedAirports": bulkEdit?.airportNotAllowed ? null : undefined,
            "old_tarfPCC_VIT": bulkEdit?.PCCDuTariff ? "" : undefined,
            "tarifPCC_FUN": bulkEdit?.PCCDuTariff ? "" : undefined,
            "tarifPCC_SKY": bulkEdit?.PCCDuTariff ? "" : undefined,
            "tarifPCC_TC": bulkEdit?.PCCDuTariff ? "" : undefined,
            "tarifPCC_DFW": bulkEdit?.PCCDuTariff ? "" : undefined,
            "distributionChannels": bulkEdit?.cannotBeDistributed ? [] : undefined,
        }

        let classData = {
            "osi": bulkEdit?.OSI ? "" : undefined,
            "permitBranchPNR": bulkEdit?.branchFiles ? null : undefined,
            "issueAsBulk": bulkEdit?.issueAsBulk ? null : undefined,
            "accountCode": bulkEdit?.accountCode ? { "DFW": "", "FUN": "", "SKY": "", "TC": "", "VIT": "" } : undefined,
            "ticketDesignator": bulkEdit?.ticketDesignator ? { "DFW": "", "FUN": "", "SKY": "", "TC": "", "VIT": "" } : undefined,
        }


        let prixData = {

            "prixLastReturnDate": bulkEdit?.lastReturnDate ? null : undefined,
            "prixLastTicketingDate": bulkEdit?.lastTicketingDate ? null : undefined,
            "endorsement": bulkEdit?.endorsement ? { "TC": "", "DFW": "", "FUN": "", "SKY": "", "VIT": "" } : undefined,

        }
        const payload = {
            "tarifKeys": (checkBoxObject?.tarifs?.length && (tarifData)) ? checkBoxObject?.tarifs : undefined,
            "tarifData": (checkBoxObject?.tarifs?.length && (tarifData)) ? tarifData : undefined,
            "classKeys": (checkBoxObject?.classes?.length && (classData)) ? checkBoxObject?.classes : undefined,
            "classData": (checkBoxObject?.classes?.length && (classData)) ? classData : undefined,
            "prixKeys": (checkBoxObject?.prixs?.length && (prixData)) ? checkBoxObject?.prixs : undefined,
            "prixData": (checkBoxObject?.prixs?.length && (prixData)) ? prixData : undefined
        }

        const bulkUpdateResponse = await putBulkUpdate(payload)
        if (bulkUpdateResponse?.message != "Bulk update was successful") {
            if(bulkUpdateResponse?.errorDetails){
                showDetailedErrorSwal({
                    message: bulkUpdateResponse?.message,
                    errorDetails: bulkUpdateResponse?.errorDetails
                });
            }else{
                showDetailedErrorSwal({
                    message: bulkUpdateResponse?.status,
                    errorDetails: bulkUpdateResponse?.message,
                });
            }
        } else {
            swal({
                text: bulkUpdateResponse?.message,
                icon: "success",
                button: "Close",
                timer: 2000,
            })
            dispatch(setSearchAllV2([]))
            history.push(`/Newcontractlist`)
        }
    }



    return (
        <>
            <div className="cm-head-2 mb-8">
                <div className="d-flex justify-content-between">
                    <span className="cm__Title">Bulk Edit</span>
                    <span></span>
                </div>
            </div>
            <div className="card cm-card">
                <div className="card-body">
                    {/* >>>>>>>>>>>>>>>>>>>>> tariff Search >>>>>>>>>>>>>>>>>>>>>. */}
                    {checkBoxObject?.tarifs?.length ?
                        <>
                            <div className="cm-head-2 cm-col">
                                <div className="d-flex justify-content-between">
                                    <span className="">Tariff </span>
                                    <div className="cm-head-checkbox d-flex">
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="row cm-col">
                                    <div className="col-md-3 cm-col bulkEmptySameLine" >
                                        <div>
                                            <label className="cm-head-label">Marketing Airlines</label>
                                            <input
                                                className="form-control cm-input"
                                                disabled={true}
                                            />
                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.marketingAirline} onChange={() => handleBulkEdit("marketingAirline")} />
                                    </div>

                                    <div className="col-md-3 cm-col bulkEmptySameLine">
                                        <div>
                                            <label className="cm-head-label">Operating Airlines</label>
                                            <input
                                                className="form-control cm-input"
                                                disabled={true}
                                            />
                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.operatingAirline} onChange={() => handleBulkEdit("operatingAirline")} />
                                    </div>


                                </div>

                                <div className="cm-head-2 cm-col">
                                    <div className="d-flex justify-content-between">
                                        <span className="">Routings </span>
                                        <div className="cm-head-checkbox d-flex">
                                        </div>
                                    </div>
                                </div>
                                <div className="row cm-col">
                                    <div className="col-md-3 bulkEmptySameLine">
                                        <div className="cm-col">
                                            <label className="cm-head-label">Airport not allowed</label>
                                            <input className="form-control cm-input autoCapitalise" type="text" disabled={true} />
                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.airportNotAllowed} onChange={() => handleBulkEdit("airportNotAllowed")} />
                                    </div>
                                </div>


                                <div className="cm-head-2 cm-col">
                                    <div className="d-flex justify-content-between">
                                        <span className="">Distribution </span>
                                        <div className="cm-head-checkbox d-flex">
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="bulkEmptySameLine">

                                        <CheckBoxTypeSelector checkBoxTypes={[
                                            'Sky Link',
                                            'Intair Transit',
                                            'Fun Sun',
                                            'DFW',
                                            'Sunquest',
                                            'Network'
                                        ]} mainLabel={"Distribution"} useStateVariable={distribution} setMethod={setDistribution} />

                                        <Checkbox color="primary" checked={bulkEdit?.distribution} onChange={() => handleBulkEdit("distribution")} />
                                    </div>

                                    <div className="col-md-3">
                                        <div className='bulkEmptySameLine'>
                                            <div className="cm-col custom-disabled-field">
                                                <label className="cm-head-label">Can not be distributed</label>
                                                <FormControlLabel control={<Checkbox color="primary" disabled={true} />}
                                                    label="Internal Users"
                                                    disabled={true}

                                                />
                                                <FormControlLabel
                                                    control={<Checkbox color="primary" disabled={true} />}
                                                    label="External Users"
                                                    disabled={true}
                                                />
                                                <FormControlLabel
                                                    control={<Checkbox color="primary" disabled={true} />}
                                                    label="XML - B2C"
                                                    disabled={true}
                                                />
                                            </div>
                                            <Checkbox color="primary" checked={bulkEdit?.cannotBeDistributed} onChange={() => handleBulkEdit("cannotBeDistributed")} />
                                        </div>
                                    </div>

                                    <div className="col-md-6 bulkEmptySameLine">
                                        <div>
                                            <label className="cm-head-label">PCC DU TARIFF</label>
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="cm-head-label">VIT</label>
                                                    <input className="form-control cm-input autoCapitalise" disabled={true} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="cm-head-label">FUN</label>
                                                    <input className="form-control cm-input autoCapitalise" disabled={true} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="cm-head-label">SKY</label>
                                                    <input className="form-control cm-input autoCapitalise" disabled={true} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="cm-head-label">TC</label>
                                                    <input className="form-control cm-input autoCapitalise" disabled={true} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="cm-head-label">DFW</label>
                                                    <input className="form-control cm-input autoCapitalise" disabled={true} />
                                                </div>
                                            </div>

                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.PCCDuTariff} onChange={() => handleBulkEdit("PCCDuTariff")} />
                                    </div>
                                </div>

                            </div>
                        </>
                        :
                        null
                    }

                    {checkBoxObject?.classes?.length ?
                        <>
                            <div className="row headerCollap">
                                <div className="col-6">
                                    <p className="headerTitle">Class</p>
                                </div>
                                <div className="col-6 text-right" >
                                    <i className="fas fa-caret-up" aria-hidden="true"></i>
                                </div>
                            </div>

                            <div>
                                <div className="cm-head-2">
                                    <div className="d-flex justify-content-between">
                                        <span className="">Rules</span>
                                        <div className="cm-head-checkbox d-flex">
                                        </div>
                                    </div>

                                </div>

                                <div className="row">

                                    <div className="col-md-6 cm-col bulkEmptySameLine">
                                        <div>
                                            <label className="cm-head-label">OSI </label>
                                            <textarea className="form-control cm-input" style={{ "height": "90px" }} disabled={true} />
                                        </div>

                                        <Checkbox color="primary" checked={bulkEdit?.OSI} onChange={() => handleBulkEdit("OSI")} />
                                    </div>


                                    <div className='bulkEmptySameLine'>
                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">Branch files</label>
                                            <FormControlLabel control={<Checkbox color="primary" disabled={true} />} label="Branch files not permitted" />
                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.branchFiles} onChange={() => handleBulkEdit("branchFiles")} />
                                    </div>
                                </div>


                                <div className="cm-head-2">
                                    <div className="d-flex justify-content-between">
                                        <span className="">Price At Sabre</span>
                                        <div className="cm-head-checkbox d-flex">
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-4">

                                    <div className="col-md-3 cm-col bulkEmptySameLine">
                                        <div >
                                            <label className="cm-head-label"> </label>
                                            <FormControlLabel control={<Checkbox color="primary" disabled={true} />} label="Issue ticket as bulk only" />
                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.issueAsBulk} onChange={() => handleBulkEdit("issueAsBulk")} />
                                    </div>


                                </div>
                                <div className='row'>
                                    <div className="col-md-12 cm-col bulkEmptySameLine">
                                        <div className='col-md-2'>
                                            <label className="cm-head-label">ACCOUNT CODE</label>
                                        </div>
                                        <div>
                                            <Checkbox color="primary" checked={bulkEdit?.accountCode} onChange={() => handleBulkEdit("accountCode")} />
                                        </div>
                                    </div>


                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">VIT</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">SKY</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">DFW</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">FUN</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">TC</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>


                                </div>

                                <div className='row'>
                                    <div className="col-md-12 cm-col bulkEmptySameLine">
                                        <div className='col-md-2'>
                                            <label className="cm-head-label">TICKET DESIGNATOR</label>
                                        </div>
                                        <div>
                                            <Checkbox color="primary" checked={bulkEdit?.ticketDesignator} onChange={() => handleBulkEdit("ticketDesignator")} />
                                        </div>
                                    </div>

                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">VIT</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">SKY</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">DFW</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">FUN</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                    <div className="col-md-3 cm-col">
                                        <label className="cm-head-label">TC</label>
                                        <input className="form-control cm-input" disabled={true} />
                                    </div>
                                </div>


                            </div>
                        </>
                        : null}

                    {checkBoxObject?.prixs?.length ?
                        <>
                            <div className="row headerCollap">
                                <div className="col-12">
                                    <p className="headerTitle">Prix</p>
                                </div>
                            </div>

                            <div>



                                <div className="row align-items-end">

                                    <div className="col-md-3 cm-col bulkEmptySameLine">
                                        <div className=''>
                                            <label className="cm-head-label">Last Return Date</label>

                                            <input
                                                disabled={true}
                                            />
                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.lastReturnDate} onChange={() => handleBulkEdit("lastReturnDate")} />
                                    </div>
                                    <div className="col-md-3 cm-col bulkEmptySameLine">
                                        <div>
                                            <label className="cm-head-label">Last Ticketing Date</label>

                                            <input disabled={true} />
                                        </div>
                                        <Checkbox color="primary" checked={bulkEdit?.lastTicketingDate} onChange={() => handleBulkEdit("lastTicketingDate")} />
                                    </div>
                                </div>
                            </div>
                        </>
                        : null}


                </div>
            </div >


            {checkBoxObject?.prixs?.length ?
                <div className="card cm-card">
                    <div className="card-body">
                        <div className="cm-head-2">
                            <div className="d-flex justify-content-between">
                                <span className="">Emission </span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 cm-col bulkEmptySameLine">
                                <div className='col-md-2'>
                                    <label className="cm-head-label">Endorsement</label>
                                </div>
                                <div>
                                    <Checkbox color="primary" checked={bulkEdit?.endorsement} onChange={() => handleBulkEdit("endorsement")} />
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">VIT</label>
                                <input className="form-control cm-input" disabled={true} />
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">SKY</label>
                                <input className="form-control cm-input" disabled={true} />
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">DFW</label>
                                <input className="form-control cm-input" disabled={true} />
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">FUN</label>
                                <input className="form-control cm-input" disabled={true} />
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">TC</label>
                                <input className="form-control cm-input" disabled={true} />
                            </div>
                        </div>

                    </div>
                </div>
                : null}


            <div className="card cm-card">
                <div className="card-body">
                    <div className="row cm-col">
                        <div className="col-md-12 cm-col text-right">
                            <button className="cm-secondary-btn mr-2 " onClick={() => history.push('/newcontractlist')}>Cancel</button>
                            <button className='cm-primary-btn' onClick={saveHandle}>Save</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BulkEmpty